import { ca } from '@cian/analytics';

import { getPlaceType } from './getPlaceType';
import { TProduct } from '../../../types/analytics';

interface ITrackSendMessageClickParams {
  label: string;
  product: TProduct;
  isPromoSnippet?: boolean;
}

export function trackSendMessageClick({ label, product, isPromoSnippet }: ITrackSendMessageClickParams) {
  ca('eventSite', {
    action: 'send_message',
    category: 'ListingJK',
    label,
    name: 'oldevent',
    products: [product],
    page: {
      extra: {
        type: getPlaceType(isPromoSnippet),
      },
    },
  });
}
